/**
 * Formats a count for compact display.
 * Values >= 1000 are expressed in thousands with up to 2 decimal places and trailing zeros stripped.
 *
 * Examples: 999 → "999", 1000 → "1k", 1500 → "1.5k", 4320 → "4.32k", 12345 → "12.35k"
 */
export function formatCount(n: number): string {
  if (n < 1000) return String(n);
  return (n / 1000).toFixed(2).replace(/\.?0+$/, '') + 'k';
}
